import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getBrandPrefix } from "../../../helpers/restaurantSlugDetector";
import Ink from "react-ink";

/**
 * Select Another Location Button
 * Shows a floating button when brand has multiple locations
 * Allows user to switch to a different store location
 */
class SelectAnotherLocation extends Component {
	handleClick = () => {
		const brandSlug = getBrandPrefix();
		if (brandSlug) {
			this.props.history.push(`/${brandSlug}/select-location`);
		}
	};

	render() {
		const { hasMultipleLocations, brand, currentRestaurant } = this.props;

		// Only show if brand has multiple locations
		if (!hasMultipleLocations || !brand) {
			return null;
		}

		return (
			<>
				{/* Banner at top of page */}
				<div
					className="location-banner"
					style={{
						background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
						color: "#fff",
						padding: "12px 15px",
						position: "sticky",
						top: 0,
						zIndex: 999,
						boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
					}}
				>
					<div className="d-flex align-items-center justify-content-between">
						<div className="flex-grow-1">
							<div className="d-flex align-items-center">
								<i className="si si-location-pin mr-2" style={{ fontSize: "1.2rem" }}></i>
								<div>
									<p className="mb-0 font-w600" style={{ fontSize: "0.9rem" }}>
										{currentRestaurant ? currentRestaurant.name : brand.name}
									</p>
									<p className="mb-0" style={{ fontSize: "0.75rem", opacity: 0.9 }}>
										{brand.name} - Multiple Locations Available
									</p>
								</div>
							</div>
						</div>
						<button
							className="btn btn-sm px-3"
							onClick={this.handleClick}
							style={{
								background: "rgba(255,255,255,0.2)",
								color: "#fff",
								border: "1px solid rgba(255,255,255,0.3)",
								borderRadius: "20px",
								fontSize: "0.8rem",
								fontWeight: "600",
								position: "relative",
							}}
						>
							<Ink duration={400} />
							<i className="si si-direction mr-1"></i>
							Change
						</button>
					</div>
				</div>

				{/* Floating Bottom Button (Alternative) */}
				{/* Uncomment if you prefer a floating button instead of banner
				<div
					className="floating-location-button"
					style={{
						position: "fixed",
						bottom: "80px",
						left: "50%",
						transform: "translateX(-50%)",
						zIndex: 999,
					}}
				>
					<button
						className="btn btn-lg"
						onClick={this.handleClick}
						style={{
							background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
							color: "#fff",
							border: "none",
							borderRadius: "25px",
							padding: "12px 30px",
							boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
							fontSize: "0.9rem",
							fontWeight: "600",
							position: "relative",
						}}
					>
						<Ink duration={400} />
						<i className="si si-location-pin mr-2"></i>
						Select Another Location
					</button>
				</div>
				*/}
			</>
		);
	}
}

const mapStateToProps = (state) => ({
	currentRestaurant: state.singlestore.currentRestaurant,
	brand: state.singlestore.brand,
	hasMultipleLocations: state.singlestore.hasMultipleLocations,
	restaurantSlug: state.singlestore.restaurantSlug,
});

export default connect(mapStateToProps)(withRouter(SelectAnotherLocation));

